const REPORT_TYPES = [
  { value: '', label: 'Seleccionar tipo de reporte' },
  { value: 'trianual', label: 'Trianual' },
  { value: 'toolbox', label: 'ToolBox' },
  { value: 'amarre', label: 'Amarre' },
];

export function getReportTypeOptions() {
  return REPORT_TYPES;
}

export function buildReportesFromEvaluaciones(evaluacionesCompletadas) {
  return evaluacionesCompletadas.map((item) => ({
    id: item.id,
    fecha: item.fecha,
    legajo: item.legajoEvaluado,
    evaluados: item.nombreEvaluado,
    evaluacion: item.etiquetaReporte || 'TRIANUAL',
    tipo: item.tipoReporte || 'trianual',
  }));
}
